enum EnumOrderType {
  Lieferung = 1,
  Abholung = 2,
  Restaurant = 3,
}

export default EnumOrderType;
